const defaultState = {
  isFetching: false,
  byId: {},
  error: undefined,
};

export default function offersReducer(state = defaultState, action) {
  switch (action?.type) {
    default:
      return state;
  }
}
